export default __webpack_public_path__ + "static/media/moodle.b3b9e95c.png";